import React, { useState } from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

import interfaceArrowsButtonLeft from '../../../images/global/interface-arrows-button-left.svg'
import interfaceArrowsButtonRight from '../../../images/global/interface-arrows-button-right.svg'

import WithIsVisible from '../../WithIsVisible'
import Link from '../../Link'
import Svg from '../../SVG'

const ImageBlock = ({ images }) => {
    const _images = images?.filter(({ small, localFile }) => {
        if (
            typeof small === 'undefined' &&
            typeof localFile?.publicURL !== 'undefined'
        )
            return true
        if (small !== null && typeof small !== 'undefined') return true

        return false
    })

    return _images?.length > 2 ? (
        <div className="relative flex flex-col w-full">
            <div className="md:flex-row h-1/2 flex flex-col flex-1 w-full bg-white bg-opacity-50">
                {_images?.map((image, i) =>
                    i < 2 ? (
                        <div
                            key={i}
                            className={`${
                                i === 0 ? 'block' : 'hidden md:block'
                            } flex-1 h-full w-full md:w-1/2 relative`}
                        >
                            <div className="xl:h-full xl:absolute xl:top-0 xl:left-0 w-full">
                                {image?.small ? (
                                    <GatsbyImage
                                        image={getImage(image?.small)}
                                        className="xl:h-full xl:absolute xl:top-0 xl:left-0 w-full"
                                        alt="Ministry of Defence"
                                    />
                                ) : (
                                    <div
                                        style={{
                                            backgroundImage: `url(${image?.localFile?.publicURL})`,
                                        }}
                                        className="xl:h-full xl:absolute xl:top-0 xl:left-0 pt-3/4 xl:pt-0 w-full bg-center bg-cover"
                                    />
                                )}
                            </div>
                        </div>
                    ) : null
                )}
            </div>
            <div className="md:flex h-1/2 flex flex-1 hidden w-full">
                {_images?.map((image, i) =>
                    i >= 2 ? (
                        <div key={i} className="relative flex-1 w-1/2 h-full">
                            <div className="xl:h-full xl:absolute xl:top-0 xl:left-0 w-full">
                                {image?.small ? (
                                    <GatsbyImage
                                        image={getImage(image?.small)}
                                        className="xl:h-full xl:absolute xl:top-0 xl:left-0 w-full"
                                        alt="Ministry of Defence"
                                    />
                                ) : (
                                    <img
                                        src={image?.localFile?.publicURL}
                                        className="xl:h-full xl:absolute xl:top-0 xl:left-0 w-full"
                                        alt="Ministry of Defence"
                                    />
                                )}
                            </div>
                        </div>
                    ) : null
                )}
            </div>
        </div>
    ) : (
        <div className="relative flex w-full h-full">
            {_images?.map((image, i) => (
                <div
                    key={i}
                    className={`${
                        _images?.length === 1
                            ? 'w-full pt-3/4 xl:pt-0'
                            : 'w-full md:w-1/2 pt-3/4 md:pt-1/2 xl:pt-0'
                    } ${i > 0 ? 'hidden md:block' : 'block'} relative`}
                >
                    <div className="absolute top-0 left-0 w-full h-full">
                        {image?.full || image?.half ? (
                            <GatsbyImage
                                image={
                                    _images?.length === 1
                                        ? getImage(image?.full)
                                        : getImage(image?.half)
                                }
                                className="absolute top-0 left-0 w-full h-full"
                                alt="Ministry of Defence"
                            />
                        ) : (
                            <div
                                style={{
                                    backgroundImage: `url(${image?.localFile?.publicURL})`,
                                }}
                                className="absolute top-0 left-0 w-full h-full bg-center bg-cover"
                            />
                        )}
                    </div>
                </div>
            ))}
        </div>
    )
}

const ProductsCarousel = ({
    primary: _primary,
    carouselProductsPrimary,
    items: _items,
    carouselProductsItems,
    accent_colour,
}) => {
    const primary = carouselProductsPrimary || _primary
    const items = carouselProductsItems || _items
    const [activeIndex, setActiveIndex] = useState(0)

    const handlePrev = () => {
        setActiveIndex(activeIndex === 0 ? items?.length - 1 : activeIndex - 1)
    }

    const handleNext = () => {
        setActiveIndex(
            activeIndex + 1 > items?.length - 1 ? 0 : activeIndex + 1
        )
    }

    return items?.length > 0 ? (
        <div
            className={`${
                primary?.space_top === 'No'
                    ? 'pb-12 md:pb-20'
                    : 'py-12 md:py-20'
            } relative bg-primary text-center xl:text-left`}
        >
            <WithIsVisible
                children={({ isVisible, active }) => (
                    <div className="md:px-12 lg:px-20 container px-8 mx-auto">
                        {primary?.heading ? (
                            <h2 className="md:text-5xl xl:text-7xl text-opacity-5 text-4xl font-bold text-black uppercase select-none">
                                <span
                                    className={`inline-block transform ${
                                        isVisible || !active
                                            ? 'translate-x-0 opacity-100'
                                            : '-translate-x-32 opacity-0'
                                    } transition duration-500`}
                                >
                                    {primary?.heading}
                                </span>
                            </h2>
                        ) : null}

                        <div className="xl:flex-row md:mt-12 bg-navy flex flex-col mt-8 text-white">
                            <div className="xl:w-2/3 flex flex-1 w-full">
                                <ImageBlock
                                    {...{
                                        images: [
                                            items?.[activeIndex]?.image_one ||
                                                null,
                                            items?.[activeIndex]?.image_two ||
                                                null,
                                            items?.[activeIndex]?.image_three ||
                                                null,
                                            items?.[activeIndex]?.image_four ||
                                                null,
                                        ],
                                    }}
                                />
                            </div>
                            <div className="xl:w-1/3 xl:p-12 xl:pb-0 flex flex-col justify-between w-full p-8 pb-0">
                                <div>
                                    {items?.map(
                                        (
                                            {
                                                subheading,
                                                heading,
                                                description,
                                                link,
                                                button_label,
                                                armed_force,
                                            },
                                            i
                                        ) => (
                                            <div
                                                key={i}
                                                className={`${
                                                    activeIndex === i
                                                        ? 'block'
                                                        : 'hidden'
                                                }`}
                                            >
                                                <span className="text-sm font-bold tracking-widest text-white uppercase">
                                                    {subheading}
                                                </span>
                                                <h2 className="md:text-2xl mt-4 mb-8 text-xl font-bold">
                                                    {heading}
                                                </h2>
                                                <div className="xl:min-h-32 xl2:min-h-64 text-xs">
                                                    <span className="xl:mx-0 block max-w-sm mx-auto">
                                                        {description}
                                                    </span>
                                                    {link && button_label ? (
                                                        <div>
                                                            <Link
                                                                to={
                                                                    link?.uid
                                                                        ? `/${
                                                                              link?.uid ===
                                                                              'home'
                                                                                  ? ''
                                                                                  : link?.uid
                                                                          }`
                                                                        : link?.url
                                                                }
                                                                external={
                                                                    !link?.uid
                                                                }
                                                                className="group sm:w-auto md:mt-8 hover:scale-110 bg-blue inline-flex items-center justify-center w-full h-12 px-8 mt-4 text-sm font-bold text-white uppercase transition duration-200 transform"
                                                                style={{
                                                                    backgroundColor:
                                                                        accent_colour,
                                                                }}
                                                            >
                                                                {button_label}
                                                                <Svg
                                                                    src={
                                                                        interfaceArrowsButtonRight
                                                                    }
                                                                    className="flex-0 relative z-10 w-3 h-auto ml-4 text-white"
                                                                />
                                                            </Link>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>
                                        )
                                    )}
                                </div>
                                <div className="xl:mt-12 mt-8">
                                    <ul className="flex justify-center h-8 mb-4">
                                        {items?.map((item, i) => (
                                            <li key={i}>
                                                <button
                                                    className="inline-flex items-center justify-center w-4 h-4"
                                                    onClick={() =>
                                                        setActiveIndex(i)
                                                    }
                                                >
                                                    <span
                                                        className={`w-1 h-1 bg-white ${
                                                            activeIndex === i
                                                                ? 'bg-opacity-100 pointer-events-none'
                                                                : 'bg-opacity-50'
                                                        } rounded-full select-none`}
                                                    />
                                                </button>
                                            </li>
                                        ))}
                                    </ul>
                                    <div className="xl:-mx-12 bg-greyblue flex items-center justify-between h-12 -mx-8">
                                        <button
                                            type="button"
                                            className="group relative inline-flex items-center justify-start w-1/2 h-12 px-8 text-sm font-bold text-white uppercase transition"
                                            onClick={handlePrev}
                                        >
                                            <span
                                                className="bg-grey group-hover:opacity-100 group-hover:visible absolute top-0 left-0 invisible block w-full h-full transition opacity-0 pointer-events-none"
                                                style={{
                                                    backgroundColor:
                                                        accent_colour,
                                                }}
                                            />
                                            <Svg
                                                src={interfaceArrowsButtonLeft}
                                                className="flex-0 relative z-10 w-3 h-auto mr-4 text-white"
                                            />
                                            <span className="group-hover:scale-110 block transition duration-100 transform">
                                                Prev
                                                <span className="sm:inline xl:hidden 2xl:inline hidden">
                                                    ious
                                                </span>
                                            </span>
                                        </button>
                                        <button
                                            type="button"
                                            className="group relative inline-flex items-center justify-end w-1/2 h-12 px-8 text-sm font-bold text-white uppercase transition"
                                            onClick={handleNext}
                                        >
                                            <span
                                                className="bg-grey group-hover:opacity-100 group-hover:visible absolute top-0 left-0 invisible block w-full h-full transition opacity-0 pointer-events-none"
                                                style={{
                                                    backgroundColor:
                                                        accent_colour,
                                                }}
                                            />
                                            <span className="group-hover:scale-110 block transition duration-100 transform">
                                                Next
                                            </span>
                                            <Svg
                                                src={interfaceArrowsButtonRight}
                                                className="flex-0 relative z-10 w-3 h-auto ml-4 text-white"
                                            />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            />
        </div>
    ) : null
}

export default ProductsCarousel
